import React, { useState, useEffect } from 'react';

const WidgetWrapper = ({ 
  title, 
  loading = false, 
  error = null, 
  children, 
  darkMode = false,
  className = ''
}) => {
  const [windowWidth, setWindowWidth] = useState(() => typeof window !== 'undefined' ? window.innerWidth : 1200);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const isMobile = windowWidth < 800;
  
  const baseStyles = {
    padding: isMobile ? '8px' : '16px',
    borderRadius: '8px',
    backgroundColor: darkMode ? '#1e293b' : '#ffffff',
    color: darkMode ? '#e2e8f0' : '#1e293b',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    minHeight: isMobile ? '80px' : '120px',
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    minWidth: '0'
  };

  const headerStyles = {
    fontSize: isMobile ? '12px' : '14px',
    fontWeight: '600',
    marginBottom: isMobile ? '6px' : '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${darkMode ? '#334155' : '#e2e8f0'}`,
    paddingBottom: isMobile ? '4px' : '8px'
  };

  const contentStyles = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  };

  const loadingStyles = {
    color: darkMode ? '#94a3b8' : '#64748b',
    fontSize: '14px',
    textAlign: 'center'
  };

  const errorStyles = {
    color: '#ef4444',
    fontSize: '13px',
    padding: '8px',
    backgroundColor: darkMode ? '#450a0a' : '#fef2f2',
    borderRadius: '4px'
  };

  return (
    <div style={baseStyles} className={`widget-wrapper ${className}`}>
      {title && (
        <div style={headerStyles}>
          <span>{title}</span>
        </div>
      )}
      
      <div style={contentStyles}>
        {loading && (
          <div style={loadingStyles}>
            Loading...
          </div>
        )}
        
        {error && (
          <div style={errorStyles}>
            ⚠️ Error: {error}
          </div>
        )}
        
        {!loading && !error && children}
      </div>
    </div>
  );
};

// Widget metadata (for registry)
WidgetWrapper.widgetId = 'widget-wrapper';
WidgetWrapper.defaultSize = { cols: 6 };

export default WidgetWrapper;